import {combineReducers} from "redux";
import { slice } from "./Slice";
import * as auth from "./authRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  save: slice.reducer,
});
